
import { mapState, mapActions } from 'vuex'
import FormField from './FormField.vue'

export default {
  name: 'DefaultForm',
  components: {
    FormField
  },
  props: {
    formTitle: {
      type: String,
      default: null
    },
    columns: {
      type: Number,
      default: 1
    },
    cta: {
      type: String,
      default: 'Submit'
    },
    cancelCta: {
      type: String,
      default: null
    },
    hideCta: {
      type: Boolean,
      default: false
    },
    fields: {
      type: Array,
      default: []
    },
    message: {
      type: String,
      default: null
    },
    onSubmit: {
      type: Function,
      default: () => {}
    },
    onCancel: {
      type: Function,
      default: () => {}
    },
    submitIcon: {
      type: Boolean,
      default: false
    },
    ctaClasses: {
      type: String,
      default: 'btn primary'
    },
    provider: {
      type: String,
      default: ''
    },
    passwordCriteria: {
      type: Array,
      default: () => {
        return [
          {
            name: 'length',
            valid: false,
            regex: '.{8,}'
          },
          {
            name: 'uppercase',
            valid: false,
            regex: '[A-Z]'
          },
          {
            name: 'lowercase',
            valid: false,
            regex: '[a-z]'
          },
          {
            name: 'number',
            valid: false,
            regex: '[0-9]'
          },
          {
            name: 'special',
            valid: false,
            regex: '[@$!%*?&]'
          },
        ]
      }
    },
  },
  computed: {
    ...mapState([ 'loading' ]),
    isFormValid() {
      // Check if all required fields are filled
      const allRequiredFilled = this.formFields.every(field => field.required && field.value.trim() !== '');

      // Check if values of fields with a "valid" property match the specified regex
      const isValidRegex = this.formFields.every(field => {
        if (field.valid && field.value.trim() !== '') {
          const regex = new RegExp(field.valid);
          return regex.test(field.value);
        }
        return true; // Skip fields without "valid" property
      });

      return allRequiredFilled && isValidRegex;
    },
  },
  data() {
    let formFields = []
    this.fields.map(f => {
      let field = this.$utils.copy(f)
      field.valid = f.valid
      if(field.type !== 'link') {
        if(typeof field.value === 'undefined') {
          field.value = ''
        }
        if(typeof field.touched === 'undefined') {
          field.touched = false
        }
        if(typeof field.error === 'undefined') {
          field.error = null
        }
      }
      formFields.push(field)
    })
    return {
      formFields,
      pMatch: null,
    }
  },
  methods: {
    ...mapActions([ 'trackEvent', 'lookupUser' ]),
    async validate(t) {
      let valid = false
      switch(t.type) {
        case 'link':
          return true
        case 'loc-search':
          if (t.required) {
            valid = t.value ? true : false
            t.error = valid ? null : t.errors.invalid
          } else {
            valid = true
          }
          return valid
        case 'checkbox':
          if (t.required) {
            valid = t.value
          } else {
            valid = true
          }
          t.error = valid ? null : t.errors.invalid
          return valid
        case 'password':
          if (t.name === 'confirm-password') {
            valid = this.pMatch && t.value === this.pMatch ? true : false
            t.error = valid ? null : t.errors.invalid
            return valid
          } else {
            this.pMatch = t.value
            valid = t.value.match(t.valid)
            t.error = valid ? null : t.errors.invalid
            return valid
          }
        case 'tel':
          valid = t.value.replace(/[- )(]/g,'').match(t.valid)
          if (valid && this.provider === 'spendgo') {
            let status = await this.lookupUser({phone: t.value.replace(/[- )(]/g,'')})
            if (status?.status === 'Activated') {
              t.error = 'Oops, this number is already registered. Please <a href="/account/signin">Sign In</a> with your your existing Spendgo account to join this program.'
              return false
            }
          }
          t.error = valid ? null : t.errors.invalid
          return valid

        case 'email':
          valid = t.value.match(t.valid)
          if (valid && this.provider === 'spendgo') {
            let status = await this.lookupUser({email: t.value})
            if (status?.status === 'Activated') {
              t.error = 'Oops, this email is already registered. Please <a href="/account/signin">Sign In</a> with your existing Spendgo account to join this program.'
              return false
            }
          }
          t.error = valid ? null : t.errors.invalid
          return valid
        
        default:
          if (!t.value && !t.required) {
            t.error = ''
            return true
          }
          valid = t.value.match(t.valid)
          t.error = valid ? null : t.errors.invalid
          return valid
      }
    },
    eventTracking(item) {
      if (item.type === 'sign-in') {
        //TODO for sign in analytics tracking
      } else if (item.type === 'sign-up') {
        this.trackEvent({
          name: 'start_sign_up',
          windowObject: window
        })
      } else {
        this.trackEvent({
          name: 'guest_checkout',
          windowObject: window
        })
      }
    },
    handleSubmit() {
      let data = {}
      this.formFields.map(f => {
        if (this.validate(f) && f.name !== undefined) {
          if (f.type === 'tel') {
            data[f.name] = f.value.replace(/[- )(]/g,'')
          } else {
            data[f.name] = f.value
          }
        }
      })

      const errorFound = this.formFields.find(f => f.error)
      if (errorFound) {

        let $elements = document.getElementsByName(errorFound.name)
        if ($elements && $elements[0]) {
          $elements[0].scrollIntoView({ behavior: 'smooth' })

          return
        }
        
        if (errorFound.name === 'dob') {
          $elements = document.getElementsByName('month')
          if ($elements && $elements[0]) {
            $elements[0].scrollIntoView({ behavior: 'smooth' })

            return
          }
        }
      }

      if (!errorFound) {
        this.onSubmit(data)
      }
    }
  }
}
